// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FYIh","colMin":"styles_colMin__3FBmw"};